// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.datagrid .super-app-theme--header {
  background-color: #2d2a2c;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/datagrid.scss"],"names":[],"mappings":"AACE;EACE,yBAAA;AAAJ","sourcesContent":[".datagrid {\n  .super-app-theme--header {\n    background-color: #2d2a2c;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
